import Dinero from 'dinero.js'

export default class Money {

    static get precision() {
        return this._precision || 8;
    }

    static set precision(value) {
        this._precision = value
    }

    static get locale() {
        return this._locale || 'en';
    }

    static set locale(value) {
        this._locale = value
    }

    static get currency() {
        return this._currency || 'USD';
    }

    static get currencySymbol() {
        if(this.currency === 'USD') return '$'
        else if(this.currency === 'EUR') return '€'
        else if(this.currency === 'RSD') return 'Din'
        else if(this.currency === 'BAM') return 'KM'
        return this.currency
    }

    static set currency(value) {
        this._currency = value
    }

    constructor(providerValue) {
        this.providerValue = providerValue
    }

    // Provider methods
    static parse(value, precision = Money.precision) {
        // set up provider
        Dinero.globalLocale = Money.locale;
        Dinero.defaultCurrency = Money.currency;
        Dinero.defaultPrecision = precision;

        if(value === undefined || value === null) return new Money(Dinero({ amount: -1 * Math.pow(10, precision) }))

        // create provider value
        value = Math.round((parseFloat(value) + Number.EPSILON) * Math.pow(10, precision)) / Math.pow(10, precision);
        let amount = parseInt((value * Math.pow(10, precision)).toFixed(0));
        const providerValue = Dinero({ amount: amount })

        return new Money(providerValue)
    }

    add(value) {
        this.providerValue = this.providerValue.add(value.providerValue)
        return this
    }

    subtract(value) {
        this.providerValue = this.providerValue.subtract(value.providerValue)
        return this
    }

    multiply(value) {
        this.providerValue = this.providerValue.multiply(value)
        return this
    }

    divide(value) {
        this.providerValue = this.providerValue.divide(value)
        return this
    }

    percentage(value) {
        this.providerValue = this.providerValue.percentage(value)
        return this
    }

    abs(setAbs = true) {
        if(setAbs && this.providerValue.toUnit() < 0) {
            this.providerValue = this.providerValue.multiply(-1)
        }

        return this
    }

    toUnit() {
        return this.providerValue.toUnit()
    }

    toFormat(format = null) {
        let precision = 2
        if(format && format.startsWith('0.')) {
            precision = format.split('.')[1].length

            const rounded = Math.round(parseFloat((this.toUnit() * Math.pow(10, precision)).toFixed(2)))
            return (rounded / Math.pow(10, precision)).toFixed(precision)
        }

        if(format) {
            return this.providerValue.toFormat(format)
        }

        if(Money.currency === 'RSD') {
            return this.toFormat('0.00') + ' Din'
        }

        if(Money.currency === 'EUR') {
            return this.toFormat('0.00') + ' €'
        }

        if(Money.currency === 'BAM') {
            return this.toFormat('0.00') + ' KM'
        }

        return this.providerValue.toFormat()
    }

    toRoundedUnit(digits, roundingMode) {
        if(roundingMode) {
            return this.providerValue.toRoundedUnit(digits, roundingMode)
        }

        return this.providerValue.toRoundedUnit(digits)
    }

    isZero() {
        return this.providerValue.isZero()
    }
}
